<script>
	import {viewMode} from './stores/LocalStorage.js';
	import {onMount} from 'svelte'
	import Navbar from './Navbar.svelte';
	import Map from  './Map.svelte';
	import Home from './Home.svelte';
	import Docs from './Docs.svelte';
	import Pricing from './Pricing.svelte';
	import TsApps from './TSApps.svelte';
	import SmartEnvironments from './SmartEnvironments.svelte';
	import loggedInUser from './stores/LoggedInUser.js';
    import DeviceInfo from './DeviceInfo.svelte';
	
	const setViewMode = (tag, data = {}) => {
		viewMode.update({tag, data});
	}

	onMount(async () => {
		
		const response = await fetch(`/.auth/me`);
		if(response.ok) {
			const json = await response.json();
			loggedInUser.set(json[0]);
		} else {
		// Test Env - Uncomment line below to simulate login  //
		//loggedInUser.set({user_id: 'tore.skarstein@tellsens.no'});
		// Test Env //
		}
	});

	const appEvent = e => {
		if(e.detail.tag === 'view' && e.detail.app.type === 'Map') setViewMode('map', e.detail.app); 
		if(e.detail.tag === 'view' && e.detail.app.type === 'Smart Environments') setViewMode('smart environments', e.detail.app); 
	}

	const mapEvent = e => {
		if(e.detail.tag === 'apps') setViewMode('apps'); 
	}

	const navbarEvent = e => {
		if(e.detail.tag === 'home') setViewMode(e.detail.tag);
		if(e.detail.tag === 'apps') setViewMode(e.detail.tag);
		if(e.detail.tag === 'docs') setViewMode(e.detail.tag);
		if(e.detail.tag === 'pricing') setViewMode(e.detail.tag);
	}

	// Set viewmode by URL parameters
	const queryString = window.location.search;
	const urlParams = new URLSearchParams(queryString);
	const deviceId = urlParams.get('deviceId');
	const deviceEui = urlParams.get('deviceEui')
	if(deviceId) viewMode.update({tag: 'viewDevice', data: {deviceId, deviceEui}});
	history.pushState({},"tellsens.io", location.protocol + '//' + location.host + location.pathname);

</script>
 
{#if $viewMode.tag !== "map"}
<Navbar on:elementAction={navbarEvent}></Navbar>
{/if}

{#if ($viewMode.tag === 'map')}
	<Map app={$viewMode.data} on:elementAction={mapEvent}/>
{/if}


{#if ($viewMode.tag === 'smart environments')}
	<SmartEnvironments app={$viewMode.data}/>
{/if}

{#if ($viewMode.tag === 'home')}
	<Home/>
{/if}


{#if ($viewMode.tag === 'apps')}
	<section class="section">
		<TsApps on:elementAction={appEvent}/>
	</section>
{/if}

{#if ($viewMode.tag === 'docs')}
	<section class="section">
		<Docs/>
	</section>
{/if}

{#if ($viewMode.tag === 'pricing')}
	<section class="section">
		<Pricing/>
	</section>
{/if}

{#if ($viewMode.tag === 'viewDevice')}
	<section class="section">
		<DeviceInfo {deviceId}/>
	</section>
{/if}